<template>
  <div class="home">
    <innerHeader v-if="!isMobile"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="5"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top" v-if="list.length">
              <div class="article_con">
                <div class="contact">
                  <div class="contact_item">
                    <p>
                      {{ cloumnInfo.msg }}
                    </p>
                  </div>
                </div>
                <div class="theater_con">
                  <div
                    class="theater_item"
                    v-for="(t, index) in list"
                    :key="index"
                    @click="toDetail(t.id)"
                  >
                    <div class="theater_item_img">
                      <img v-lazy="t.coverImg" />
                    </div>
                    <div class="title">
                      <span> {{ t.title }}</span
                      ><img src="../../assets/img/arrow_icon.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="5"
          :cloumnId="cloumnId"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="article_con">
                <div class="contact_item">
                  <p>
                    {{ cloumnInfo.msg }}
                  </p>
                </div>
                <div class="theater_con">
                  <div
                    class="theater_item"
                    v-for="(t, index) in list"
                    :key="index"
                    @click="toDetail(t.id)"
                  >
                    <div class="theater_item_img">
                      <img :src="t.coverImg" />
                    </div>
                    <div class="title">
                      <span> {{ t.title }}</span>
                      <!-- <img src="../../assets/img/arrow_icon.png" /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div></AppcontentList
        >
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { moreTab } from '@/const';
import { fetchConentList, fetchCmsColumnList } from '@/assets/api';
export default {
  name: 'Memento',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      contentBg: require('../../assets/img/homeimgs/presi_bg.png'),
      contentBg2: require('../../assets/img/appImg/presi_bg.png'),
      currentIndex: 0,
      tabList: moreTab,

      cloumnId: '1947499391341502465', //栏目id
      cloumnInfo: {},
      list: [
        {
          title: '似是闯入梦',
          img: require('../../assets/img/activity_img4.png'),
          id: 1,
        },
        {
          title: '似是闯入梦',
          img: require('../../assets/img/activity_img4.png'),
          id: 2,
        },
        {
          title: '似是闯入梦幻地心世界',
          img: require('../../assets/img/activity_img4.png'),
          id: 3,
        },
        {
          title: '似是闯入',
          img: require('../../assets/img/activity_img4.png'),
          id: 4,
        },
        {
          title: '梦幻地心世界',
          img: require('../../assets/img/activity_img4.png'),
          id: 5,
        },
        {
          title: '地心世界',
          img: require('../../assets/img/activity_img4.png'),
          id: 6,
        },
      ],

      id: '',
    };
  },
  mounted() {
    this.getthreaterInfo();
    this.getList();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      console.log('column', column);
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    getthreaterInfo() {
      const data = {
        parentId: '1946499124172210178',
        size: 999,
        current: 1,
      };
      fetchCmsColumnList(data).then((res) => {
        if (res.code == 200) {
          const data = res.data.records;
          data.map((d) => {
            if (d.id == this.cloumnId) {
              this.cloumnInfo = d;
            }
          });
          console.log('this.cloumnInfo', this.cloumnInfo);
        }
      });
    },
    getList() {
      const data = {
        columnIds: this.cloumnId,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.list = res.records;
      });
    },
    toDetail(id) {
      this.$router.push({
        path: `/theaterDetail?id=${id}&cloumnId=${this.cloumnId}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      width: 100%;
      box-sizing: border-box;

      .contact {
        margin: 2rem 0;
        .contact_item {
          width: 100%;
          padding: 1.875rem;
          box-sizing: border-box;
          background: #fff;
          border-left: 0.3125rem solid;
          border-image: linear-gradient(
              180deg,
              rgba(170, 229, 239, 1),
              rgba(177, 187, 255, 1)
            )
            6 6;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #6b6d7a;
          font-size: 1.25rem;
          p {
            line-height: 2.5rem;
          }
        }
      }
      .theater_con {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 20px; /* 设置间距 */
        .theater_item {
          width: calc((100% - 60px) / 4);
          position: relative;
          overflow: hidden;
          margin-bottom: 3.75rem;
          border-radius: 0.5rem;

          .theater_item_img {
            width: 100%;
            overflow: hidden;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .title {
            position: absolute;
            width: 100%;
            height: 3.5rem;
            line-height: 3.5rem;
            text-align: center;
            left: 0;
            bottom: 0;
            color: #161616;
            font-size: 1.375rem;
            background: rgba(255, 255, 255, 0.6);
            box-shadow: 8px 11px 31px 0px rgba(0, 0, 0, 0.12);
            border-radius: 0px 0px 8px 8px;
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px); /* 兼容Safari */
            background-color: rgba(255, 255, 255, 0.6); /* 半透明背景增强效果 */
            border: 2px solid;
            border-image: linear-gradient(
                274deg,
                rgba(182, 182, 182, 0.5),
                rgba(255, 255, 255, 0.5),
                rgba(255, 255, 255, 1),
                rgba(255, 255, 255, 1),
                rgba(255, 255, 255, 0.5),
                rgba(182, 182, 182, 0.5)
              )
              2 2;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              position: absolute;
              right: 0.625rem;
              bottom: 0.3125rem;
              width: 2.5rem;
              height: 2.5rem;
            }
          }
        }
        &::after {
          content: '';
          flex: auto;
          width: calc((100% - 60px) / 4);
          /* 或者使用固定宽度，与项目宽度相同 */
          /* width: 30%; */
        }
      }
    }
  }

  .app_content_top {
    padding: 2rem 0;
    .article_con {
      width: 100%;
      box-sizing: border-box;

      .contact_item {
        margin-top: 1.3333rem;
        width: 100%;
        padding: 1rem 1.9167rem;
        box-sizing: border-box;
        background: #f3f3f3;
        border-left: 0.3125rem solid;
        border-image: linear-gradient(
            180deg,
            rgba(170, 229, 239, 1),
            rgba(177, 187, 255, 1)
          )
          6 6;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #6b6d7a;
        font-size: 1rem;
        p {
          line-height: 1.8333rem;
        }
      }
      .theater_con {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 0.4167rem; /* 设置间距 */
        margin-top: 1.3333rem;
        .theater_item {
          width: calc((100% - 10px) / 2);
          position: relative;
          overflow: hidden;
          margin-bottom: 1rem;
          border-radius: 0.3333rem;
          height: 9.8333rem;

          .theater_item_img {
            width: 100%;
            overflow: hidden;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .title {
            position: absolute;
            width: 100%;
            height: 2.5rem;
            line-height: 2.5rem;
            text-align: center;
            left: 0;
            bottom: 0;
            color: #161616;
            font-size: 1.1667rem;
            background: rgba(255, 255, 255, 0.6);
            box-shadow: 8px 11px 31px 0px rgba(0, 0, 0, 0.12);
            border-radius: 0px 0px 8px 8px;
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px); /* 兼容Safari */
            background-color: rgba(255, 255, 255, 0.6); /* 半透明背景增强效果 */
            border: 2px solid;
            border-image: linear-gradient(
                274deg,
                rgba(182, 182, 182, 0.5),
                rgba(255, 255, 255, 0.5),
                rgba(255, 255, 255, 1),
                rgba(255, 255, 255, 1),
                rgba(255, 255, 255, 0.5),
                rgba(182, 182, 182, 0.5)
              )
              2 2;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
              display: inline-block;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            img {
              position: absolute;
              right: 0.625rem;
              bottom: 0.3125rem;
              width: 2.5rem;
              height: 2.5rem;
            }
          }
        }
        &::after {
          content: '';
          flex: auto;
          width: calc((100% - 10px) / 2);
          /* 或者使用固定宽度，与项目宽度相同 */
          /* width: 30%; */
        }
      }
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/article_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
